export enum ModuleType {
    RESUME_BUILDER = "resume-builder",
    RESUME_SCANNER = "resume-scanner",
    COVERLETTER_BUILDER = "coverletter-builder",
    AUDIO_INTERVIEWS = "audio-interviews",
    VIDEO_INTERVIEWS = "video-interviews",
    COURSES = "courses",
    JOB_PORTAL = "job-portal",
    IMMIGRATION_ASSESSMENT = "immigration-assessment",
    STUDY_VISA_CHANCES = "study-visa-chances",
    STATUS_MANAGER = "status-manager",
    TRAVEL_LOG = "travel-log",
    AI_CHAT = "ai-chat",
    LIVE_SUPPORT = "live-support",
};

export enum ModuleFeatureValueType {
    BOOLEAN = "boolean",
    INTEGER = "integer",
};

export enum ResourceCategory {
    GET_STARTED = 'get-started',
    EVENTS = 'events',
};